import React from 'react';
import { useTheme } from "styled-components";

export const ChevronDownSvg = (props) => {

  const { width, height, color, applyThemeColor } = props;
  const theme = useTheme();
  const themeColor = `${theme?.colour?.secondary}4D`
  let colorTUse = color ?? window?.settings?.secondary_color ?? "#04333B";
  if (applyThemeColor) {
    colorTUse = themeColor;
  }
  return (
    <svg width={width ?? "14"} height={height ?? "14"} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke={colorTUse} stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}